import { FunctionComponent } from 'react';
import { TopMenuSeparator } from './TopMenuSeparator';
import TopMenuItem from './TopMenuItem';
import { MenuContextProvider } from '../menuContext';
import { TMenuItem } from '../menuTypes';
import { truncate } from '../../../../utils/truncate';

interface TopMenuContentProps {
	item: TMenuItem;
	index: number;
	isActiveItemByIndex: (index: number) => boolean;
}

const TopMenuContent: FunctionComponent<TopMenuContentProps> = ({
	item,
	index,
	isActiveItemByIndex,
}) => {
	if (item.type === 'Clickable') {
		const {
			text,
			link,
			icon,
			truncateText = true,
			truncateTextTo = 15,
		} = item;
		return (
			<MenuContextProvider
				key={`${link}${index}`}
				value={{
					index,
					isActive: isActiveItemByIndex(index),
				}}
			>
				<TopMenuItem
					icon={icon}
					text={truncateText ? truncate(text, truncateTextTo) : text}
					link={link}
				/>
			</MenuContextProvider>
		);
	}
	if (item.type === 'Separator') {
		return <TopMenuSeparator key={index} />;
	}

	return <></>;
};
export default TopMenuContent;
